/* eslint-disable no-unused-vars */
import React from 'react';
import { Box, Divider, Flex, HStack, SimpleGrid, Stack, Text, Wrap, WrapItem } from '@chakra-ui/react';
import { SocialButton } from './SocialButton';
import { FaFacebook, FaInstagram, FaLinkedin, FaTwitter } from 'react-icons/fa';
import { useTranslation } from 'react-i18next';
import { Link as RouterLink } from 'react-router-dom';
import { useRouteHelper } from '../../../hooks/routesHelpers';
import { useDetectIsLandingPage } from '../../../helpers/getIsLandingPage';
import { LocalStorageKeys, setLocalStorage } from '../../../utils/localStorageHelper';

export default function Footer() {
  const { getRoute } = useRouteHelper();
  const { t } = useTranslation();
  const isLandingPage = useDetectIsLandingPage();
  const workInProgressPage = getRoute('underConstruction');
  const privacyPolicyPage = getRoute('privacyPolicy');
  const cookiePolicyPage = getRoute('cookiePolicy');
  const termsAndConditionsPage = getRoute('termsAndConditions');
  const companyInformationPage = getRoute('companyInformation');
  const linkFacebook = 'https://www.facebook.com/Flate-104015948961297';
  const linkInstagram = 'https://www.instagram.com/flate_ita/';
  const linkLinkedin = 'https://www.linkedin.com/company/flatecom ';

  const links = [
    {
      title: t('landingPage.aboutUs'),
      links: [
        {
          label: t('landingPage.company'),
          route: linkLinkedin,
        },
        // {
        //   label: t('landingPage.investors'),
        //   route: workInProgressPage,
        // },
        {
          label: t('landingPage.carrer'),
          route: linkLinkedin,
          // badge: (
          //   <LightMode>
          //     <Badge colorScheme='purple' fontSize='0.625rem'>
          //       Hiring
          //     </Badge>
          //   </LightMode>
          // ),
        },
      ],
    },
    {
      title: 'Community',
      links: [
        {
          label: t('landingPage.owners'),
          route: linkFacebook,
        },
        {
          label: t('landingPage.tenants'),
          route: linkFacebook,
        },
        {
          label: t('landingPage.city'),
          route: linkInstagram,
          hasInternalRoute: false,
        },
      ],
    },
    // {
    //   title: t('landingPage.support'),
    //   links: [
    //     {
    //       label: t('landingPage.privacyPolicy'),
    //       route: privacyPolicyPage,
    //     },
    //     {
    //       label: t('landingPage.cookiesPolicy'),
    //       route: cookiePolicyPage,
    //       hasInternalRoute: true,
    //     },
    //     {
    //       label: t('landingPage.termsAndConditions'),
    //       route: termsAndConditionsPage,
    //       hasInternalRoute: true,
    //     },
    //   ],
    // },
    {
      title: 'Contact',
      links: [
        // {
        //   label: '+39 02 000 0000',
        //   route: '',
        // },
        {
          label: 'customer@flate.com',
          route: 'mailto:customer@flate.com',
        },
      ],
    },
  ];
  const socialLinks = [
    {
      label: 'Facebook',
      icon: <FaFacebook />,
      route: 'https://www.facebook.com/Flate-104015948961297',
    },
    {
      label: 'Instagram',
      icon: <FaInstagram />,
      route: 'https://www.instagram.com/flate_ita/',
    },
    {
      label: 'LinkedIn',
      icon: <FaLinkedin />,
      route: 'https://www.linkedin.com/company/flatecom ',
    },
    // {
    //   label: 'Twitter',
    //   icon: <FaTwitter />,
    //   route: workInProgressPage,
    // },
  ];

  const footerLinks = [
    {
      label: t('landingPage.privacyPolicy'),
      route: privacyPolicyPage,
    },
    {
      label: t('landingPage.cookiesPolicy'),
      route: cookiePolicyPage,
    },
    {
      label: t('landingPage.termsAndConditions'),
      route: termsAndConditionsPage,
    },
    {
      label: t('landingPage.modifyCookieConsent'),
      route: '/',
      handleClick: () => {
        setLocalStorage(LocalStorageKeys.CookiesAreSet, false);
        window.location.reload();
      },
    },
    {
      label: t('landingPage.companyInformation'),
      route: companyInformationPage,
    },
    // {
    //   label: 'Sitemap',
    //   route: workInProgressPage,
    // },
  ];

  return (
    <Box
      as="footer"
      bg="brand.800"
      color="white"
      paddingBottom="64px"
      paddingTop={isLandingPage ? { base: '400px', md: '380px', lg: '350px' } : '64px'}
    >
      <Box maxW="7xl" px="8" mx="auto">
        <Flex
          direction={{
            base: 'column',
            lg: 'row',
          }}
          justify="space-between"
          pb="8"
          align="flex-start"
          id="top"
        >
          <Box
            paddingEnd="12"
            mb={{
              base: '10',
              lg: 0,
            }}
          >
            <HStack spacing="4" mt="8" as="ul">
              {socialLinks.map((link, idx) => (
                <Box as="a" target="_blank" href={link.route} key={idx}>
                  <SocialButton href={link.route}>
                    <Box srOnly>{link.label}</Box>
                    {link.icon}
                  </SocialButton>
                </Box>
              ))}
            </HStack>
          </Box>
          <SimpleGrid
            w="full"
            maxW={{
              base: 'unset',
              lg: '2xl',
            }}
            columns={{
              base: 2,
              lg: 3,
            }}
            spacing={{
              base: '8',
              md: '4',
            }}
            fontSize="sm"
          >
            {links.map((group, idx) => (
              <Box key={idx}>
                <Text fontWeight="bold" mb="4">
                  {group.title}
                </Text>
                <Stack as="ul" listStyleType="none">
                  {group.links.map((link, idx) => (
                    <Box as="li" key={idx}>
                      {link.hasInternalRoute && link.hasInternalRoute ? (
                        <RouterLink to={link.route}>
                          <Box
                            _hover={{
                              textDecor: 'underline',
                            }}
                          >
                            {link.label}
                          </Box>
                        </RouterLink>
                      ) : (
                        <Box
                          as="a"
                          href={link.route}
                          target="_blank"
                          _hover={{
                            textDecor: 'underline',
                          }}
                        >
                          {link.label}
                          {/* {link?.badge && (
                                      <Box as="span" marginStart="2">
                                        {link?.badge}
                                      </Box>
                                    )} */}
                        </Box>
                      )}
                    </Box>
                  ))}
                </Stack>
              </Box>
            ))}
          </SimpleGrid>
        </Flex>
        <Divider my="10" borderColor="brand.300" />
        <Flex
          direction={{
            base: 'column-reverse',
            lg: 'row',
          }}
          align={{
            base: 'flex-start',
            lg: 'center',
          }}
          justify="space-between"
          fontSize="sm"
        >
          <Wrap
            id="bottom"
            spacing={{
              base: '4',
              lg: '8',
            }}
            mt={{
              base: '4',
              lg: '0',
            }}
          >
            <WrapItem>
              <Box> Flate ® </Box>
            </WrapItem>
            {footerLinks.map((link, idx) => (
              <WrapItem key={idx}>
                <RouterLink onClick={link.handleClick} to={link.route}>
                  {link.label}
                </RouterLink>
              </WrapItem>
            ))}
          </Wrap>
        </Flex>
      </Box>
    </Box>
  );
}
